/* Constants */
import { LATAM_NEIGHBOURHOOD_PREFIX } from 'constants/SignupConstants';

/* Type */
import type { CountryNameToCountryCodeType } from 'types/MultiScreenSignupTypes';

const DEFAULT_COUNTRY = 'United States';

export const autocompleteLatamAddressLine1 = (
  countryCode: string,
  streetAddress?: string,
  streetNumber?: string,
  route?: string,
  neighbourhood?: string,
) => {
  const streetPart =
    streetAddress || (streetNumber && route && `${route}, ${streetNumber}`);
  if (neighbourhood) {
    const prefix = LATAM_NEIGHBOURHOOD_PREFIX[countryCode] || '';
    return streetPart && `${streetPart}, ${prefix}${neighbourhood}`;
  } else {
    return streetPart;
  }
};

export const countryCodetoCountry = (
  countryCode?: string,
  countryNameToCountryCode?: CountryNameToCountryCodeType,
) => {
  if (!countryNameToCountryCode) {
    return DEFAULT_COUNTRY;
  }
  return (
    Object.keys(countryNameToCountryCode).find(
      key => countryNameToCountryCode[key] === countryCode?.toUpperCase(),
    ) || DEFAULT_COUNTRY
  );
};

export const getStatesForCountry = (
  countryName: string,
  countryNameToCountryCode?: CountryNameToCountryCodeType,
  states?: { [countryCode: string]: Array<string> | undefined },
) =>
  (countryNameToCountryCode &&
    states &&
    states[countryNameToCountryCode[countryName]]) ||
  undefined;
